module.exports = __webpack_public_path__ + "static/media/product-mast-photo.dbfbaaf8.svg";